export default __webpack_public_path__ + "static/media/copy.c1601ee8.jpg";